import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=f5c1a6e0&scoped=true&"
import script from "./DatePicker.vue?vue&type=script&lang=js&"
export * from "./DatePicker.vue?vue&type=script&lang=js&"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=f5c1a6e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c1a6e0",
  null
  
)

export default component.exports